import React, { useState, useContext, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import Autocomplete from '../../components/Autocomplete';
import Map from '../../components/Map';
import DataContext from '../../contexts/DataContext';
import { addressLookup, addressReverseGeocode, addressSuggestSingle, getCategories } from '../../api';
import formateCentroide from '../../helpers/formateCentroide';
import Fields from './Fields';

const Location = () => {
  const { updateAddress, updateLatLng, latlng, updateCategories, updateInBounds } = useContext(DataContext);
  const [initialPosition, setInitialPosition] = useState(latlng);
  const [map, setMap] = useState(null);
  const { t } = useTranslation();

  const queryParams = new URLSearchParams(window.location.search);
  const location = queryParams.get('reports.location');

  useEffect(() => {
    if (location && map) {
      addressSuggestSingle(location, (address) => {
        const gpsCoordinates = formateCentroide(address.centroide_ll);
        if (!initialPosition) setInitialPosition(gpsCoordinates);
        map.flyTo(gpsCoordinates, 12, { duration: 0.5 });
        updateAddress(address);
        updateLatLng(gpsCoordinates);
        getCategories(gpsCoordinates, (categories) => {
          updateCategories(categories);
        }, updateInBounds);
      });
    }
  }, [location, map]);

  const submitAutocomplete = useCallback((item) => {
    if (item) {
      addressLookup(item, (addressData) => {
        const gpsCoordinates = formateCentroide(addressData.centroide_ll);
        if (!initialPosition) setInitialPosition(gpsCoordinates);
        map.flyTo(gpsCoordinates, 12, { duration: 0.5 });
        updateLatLng(gpsCoordinates);
        updateAddress(addressData);
        getCategories(gpsCoordinates, (categories) => {
          updateCategories(categories);
        }, updateInBounds);
      });
    }
  }, [map]);

  const doneMovingMarker = useCallback((latlng) => {
    addressReverseGeocode(latlng, (address) => {
      const gpsCoordinates = formateCentroide(address.centroide_ll);
      updateAddress(address);
      updateLatLng(gpsCoordinates);
      getCategories(gpsCoordinates, (categories) => {
        updateCategories(categories);
      }, updateInBounds);
    });
  }, [map]);

  return (
    <div>
      <p className="Form--subtitle">{t('reports.stepper.location.subtitle')}</p>
      <span />
      <label htmlFor="autocomplete">{t('reports.stepper.location.address')} </label>
      <Autocomplete onSelect={submitAutocomplete} />
      <Map marker={initialPosition} setMap={setMap} movedMarker={doneMovingMarker} map={map} />
      <Fields map={map} afterAddressUpdate={setInitialPosition} />
    </div>
  );
};

export default Location;
